import { get, put } from "@/api";

export interface CommonGoodsInfo {
  id?: number | string;
  title?: string;
  m_pic?: string;
  code?: string;
  [key: string]: unknown;
}

export interface CommonSpecInfo {
  id?: number | string;
  name?: string;
  price?: number | string;
  unit?: string;
  stock?: number | string;
  pic?: string | null;
  is_outside?: boolean | number | string;
  [key: string]: unknown;
}

/** 常购分类下的物资行 */
export interface CommonUseGoods {
  id: number | string;
  account_id?: number | string;
  wz_common_use_type_id?: number | string;
  goods_id?: number | string;
  goods_name?: string;
  spec_id?: number | string;
  spec_name?: string;
  number?: number | string;
  goods?: CommonGoodsInfo | null;
  spec?: CommonSpecInfo | null;
  [key: string]: unknown;
}

/** 常购分类（含物资列表） */
export interface CommonUseType {
  id: number | string;
  account_id?: number | string;
  name?: string;
  created_at?: string;
  updated_at?: string;
  goods?: CommonUseGoods[];
  [key: string]: unknown;
}

export interface CommonListsResponse {
  error: boolean | number;
  message?: string;
  msg?: string;
  data?: CommonUseType[];
}

/** 获取常用分类及分类物资列表 */
export function getCommonLists() {
  return get<CommonListsResponse>("/platform/common/lists");
}

export interface CommonAddParams {
  name: string;
}

export interface CommonAddResponse {
  error: boolean | number;
  message?: string;
  msg?: string;
  data?: CommonUseType;
}

/** 新建常用分类 */
export function addCommonType(params: CommonAddParams) {
  return put<CommonAddResponse>("/platform/common/add", params);
}

export interface CommonTypeListsResponse {
  error: boolean | number;
  message?: string;
  msg?: string;
  /** 仅分类列表，不含物资 */
  data?: CommonUseType[];
}

/** 获取常用分类列表（不含物资） */
export function getCommonTypeLists() {
  return get<CommonTypeListsResponse>("/platform/common/type-lists");
}

export interface CommonAddGoodsParams {
  type_id: number | string;
  goods_id: number | string;
  spec_id: number | string;
  number: number;
}

export interface CommonAddGoodsResponse {
  error: boolean | number;
  message?: string;
  msg?: string;
}

/** 添加常用物资到常购分类 */
export function addCommonGoods(params: CommonAddGoodsParams) {
  return put<CommonAddGoodsResponse>("/platform/common/add-goods", params);
}

export interface CommonDeleteResponse {
  error: boolean | number;
  message?: string;
  msg?: string;
}

/** 删除常购物资 */
export function deleteCommonGoods(id: number | string) {
  return put<CommonDeleteResponse>(`/platform/common/delete/${id}`);
}

/** 删除常购分类（含其下物资） */
export function deleteCommonType(id: number | string) {
  return put<CommonDeleteResponse>(`/platform/common/delete-type/${id}`);
}
